import { ENV, getQuerySearchParams, i18n } from '@src/slide/application/service/edit-extension/edit-extension-export';
import { IImportNewFileManagerInjectable } from '@src/slide/application/service/import-file-manager/core/import-file-manager.interface';
import ImportNewFileManager from '@src/slide/application/service/import-file-manager/core/import-new-file-manager';
import Snackbar from '@tencent/dui/lib/components/Snackbar';

export class ImportNewFileManagerInjectable implements IImportNewFileManagerInjectable {
    declare public handleImportFileObject?: (fileObj: any) => void;

    public constructor() {
        if (ENV.IS_LOCAL_EDIT) {
            this.handleImportFileObject = this.handleImportFileForLocalEdit;
        }
    }

    public handleImportFileForLocalEdit(fileObj: any): void {
        const filePath = { path: getQuerySearchParams('localFilePath') };
        import(/* webpackChunkName: "service" */ '@tencent/docs-drive-api').then((module) => {
            const { driveApi } = module;
            driveApi.getLocalFile(filePath).then(() => {
                (this as unknown as ImportNewFileManager).showImportDialog(fileObj);
            })
                .catch((error) => {
                    console.log('driveapi error: ', error);
                    Snackbar.show({
                        type: 'error',
                        duration: 5000,
                        message: i18n.t('本地文件不存在'),
                        autoClose: true,
                    });
                });
        });
    }
}
